export { default as CarouselSwitch } from './CarouselSwitch';
